export const hasActiveFilterValue = (value) => {
  if (value === undefined || value === null || value === false) {
    return false;
  }

  if (typeof value === "string") {
    return value.trim() !== "";
  }

  if (typeof value === "number") {
    return Number.isFinite(value);
  }

  if (typeof value === "boolean") {
    return value;
  }

  if (Array.isArray(value)) {
    return value.some(hasActiveFilterValue);
  }

  if (typeof value === "object") {
    if (typeof value.isValid === "function") {
      return value.isValid();
    }

    return Object.keys(value).some((key) => {
      if (["current", "pageSize", "_timestamp"].includes(key)) {
        return false;
      }

      return hasActiveFilterValue(value[key]);
    });
  }

  return Boolean(value);
};

export const hasActiveFilters = (...values) => values.some(hasActiveFilterValue);
